import { render, staticRenderFns } from "./GroupsAdminLeague.vue?vue&type=template&id=118fa244&scoped=true&"
import script from "./GroupsAdminLeague.vue?vue&type=script&lang=js&"
export * from "./GroupsAdminLeague.vue?vue&type=script&lang=js&"
import style0 from "./GroupsAdminLeague.vue?vue&type=style&index=0&id=118fa244&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118fa244",
  null
  
)

export default component.exports